import { MeshBasicMaterial, MeshStandardMaterial } from "three";

import { ViewerModeEnum } from "../store/viewerState/ViewerMode/ViewerMode";
import { IMaterialSet, MaterialSet, IMaterialMapping } from "./MaterialManager";
import { ElementTypeEnum } from "../elementTypeMappings";
import Representation3dTypeEnum from "../model/representation3d/Representation3dTypeEnum";
import ShapeTypeEnum from "../model/representation2d/ShapeTypeEnum";

let CreateNewApartmentSelect2dMaterialSet: () => IMaterialSet;
let CreateNewFreeRoam3dMaterialSet: () => IMaterialSet;

const CreateMaterialSet = (viewerMode: ViewerModeEnum) => {
    let materialSet: IMaterialSet;
    switch (viewerMode) {
        case ViewerModeEnum.ApartmentSelect2d:
            materialSet = CreateNewApartmentSelect2dMaterialSet();
            NameMaterials("ApartmentSelect2d", materialSet);
            break;
        
        case ViewerModeEnum.FreeRoam3d:
            materialSet = CreateNewFreeRoam3dMaterialSet();
            NameMaterials("FreeRoam3d", materialSet);
            break;
        
        default:
            materialSet = new MaterialSet([]);
    };
    return materialSet;
};

const NameMaterials = (prefix: string, materialSet: IMaterialSet) => {
    materialSet.getMappings().forEach(mapping => {
        mapping.Material.name = `${prefix}-${mapping.ElementType}-material`;
    });
}

CreateNewApartmentSelect2dMaterialSet = () => {
    return new MaterialSet([
        {
            ElementType: ElementTypeEnum.Wall,
            Material: new MeshBasicMaterial({ color: "darkslategray" })
        },
        {
            ElementType: ElementTypeEnum.Space,
            Material: new MeshBasicMaterial({ color: "cornsilk" })
        },
        {
            ElementType: ElementTypeEnum.Door,
            Material: new MeshBasicMaterial({ color: "black" })
        },
        {
            ElementType: ElementTypeEnum.Window,
            Material: new MeshBasicMaterial({ color: "black" })
        },
        {
            ElementType: ElementTypeEnum.Covering,
            Material: new MeshBasicMaterial({ color: "green" })
        },
        {
            ElementType: ElementTypeEnum.Fixture,
            Material: new MeshBasicMaterial({ color: "white" })
        }
    ]);
};

CreateNewFreeRoam3dMaterialSet = () => {
    return new MaterialSet([
        {
            ElementType: ElementTypeEnum.Wall,
            Material: new MeshStandardMaterial({ color: "gray", flatShading: true, wireframe: false })
            //Material: new MeshStandardMaterial({ color: "darkSlateGray", flatShading: true, wireframe: false })
        },
        {
            ElementType: ElementTypeEnum.Space,
            Material: new MeshStandardMaterial({ color: "Gainsboro", flatShading: true, })
        },
        {
            ElementType: ElementTypeEnum.Door,
            RepresentationType: Representation3dTypeEnum.ExtrudedAreaSolid,
            Material: new MeshStandardMaterial({ color: "LightSlateGray", flatShading: true,  })
        },
        {
            ElementType: ElementTypeEnum.Door,
            RepresentationType: ShapeTypeEnum.Lineloops,
            Material: new MeshStandardMaterial({ color: "black" })
        },
        {
            ElementType: ElementTypeEnum.Window,
            Material: new MeshStandardMaterial({ color: "dodgerblue", transparent: true, opacity: 0.4, roughness: 0.3, metalness: 0.5 })
        },
        {
            ElementType: ElementTypeEnum.Covering,
            Material: new MeshStandardMaterial({ color: "white" })
        },
        {
            ElementType: ElementTypeEnum.Fixture,
            Material: new MeshStandardMaterial({ color: "white", roughness: 0.7, metalness: 0.3, transparent: false})
        }
    ]);
};

export { CreateMaterialSet, NameMaterials };



